import type { ReactNode } from 'react';

import useReactRouterPageListener from '../hooks/useReactRouterPageListener';

export const AppProvider = ({ children }: { children: ReactNode }) => {
  useReactRouterPageListener();
  return <>{children}</>;
};
